import React from 'react'
import { Text } from '@/components/common'
import useMeasure from '@/services/hooks/useMeasure'
import ApplyButton from '../ApplyButton'
import { Step } from '../types'
import ProcessGraph from './ProcessGraph'

export interface Props {
  title: string
  steps: Step[]
  formUrl: string
  className?: string
}

const Process: React.FC<Props> = ({ title, steps, formUrl, className }) => {
  const [ref, { width, height }] = useMeasure<HTMLDivElement>()

  return (
    <section className={className}>
      <div className="mx-auto max-w-[1360px] px-6 font-whitney lg:px-8">
        <Text as="h2" preset="heading.xl">
          {title}
        </Text>

        <div className="relative">
          <div className="mt-8 flex flex-col flex-wrap pl-10 md:flex-row md:pl-0">
            {steps.map(({ title, subtitle }, idx) => (
              <div
                key={idx}
                className="h-[120px] pr-8 last:pr-16 md:mb-4 md:h-auto md:w-1/4"
              >
                <div className="flex flex-col items-start md:flex-row md:items-center">
                  <Text
                    as="div"
                    preset="custom"
                    className="text-[28px] font-bold leading-none text-oxide md:ml-[14px] md:-translate-x-1/2 md:text-[3rem]"
                  >
                    {idx + 1}
                  </Text>

                  <Text as="div" preset="heading.sm lg:heading.md">
                    {title}
                  </Text>

                  <Text
                    as="div"
                    preset="body.lg"
                    className="text-gray md:hidden"
                  >
                    {subtitle}
                  </Text>
                </div>
              </div>
            ))}
          </div>

          <div
            className="absolute bottom-0 top-0 w-[30px] md:static md:flex md:h-[30px] md:w-full"
            ref={ref}
          >
            <ProcessGraph width={width} height={height} steps={steps} />
          </div>

          <div className="hidden md:flex">
            {steps.map(({ subtitle }, idx) => (
              <div key={idx} className="w-1/4 pl-4 text-center">
                <Text as="div" preset="body.lg" className="text-gray">
                  {subtitle}
                </Text>
              </div>
            ))}
          </div>
        </div>

        <ApplyButton url={formUrl} className="mt-8 md:mt-12" />
      </div>
    </section>
  )
}

export default Process
